import { commonUtils } from 'utils'
import { IContextUser } from 'contexts/AuthContext'
import { IDetailsColumnProp, IOnRiskReportColumnProp } from './OnRisk.interface'
import { CellProps } from '@inovua/reactdatagrid-community/types'
import { generateBgColor } from '../WrittenBusiness/constants'

export const onRiskReportDataSource = [
  {
    totalPutOnRisk: 6891.25,
    paid: 4041.25,
    paymentOutstanding: 4041.25,
    totalOnRiskPaymentsOutstandingYtd: 4041.25,
  },
]

export const onRiskReportColumns = [
  {
    name: 'totalPutOnRisk',
    header: 'Total put On Risk',
    defaultFlex: 1,
    type: 'number',
    render: ({ data }: IOnRiskReportColumnProp) => (data.totalPutOnRisk ? `£${commonUtils.formatNumberWithCommas(data.totalPutOnRisk)}` : '-'),
  },
  {
    name: 'paid',
    header: 'Paid',
    defaultFlex: 1,
    type: 'number',
    render: ({ data }: IOnRiskReportColumnProp) => (data.paid ? `£${commonUtils.formatNumberWithCommas(data.paid)}` : '-'),
  },
  {
    name: 'paymentOutstanding',
    header: 'Payment Outstanding',
    defaultFlex: 1,
    type: 'number',
    render: ({ data }: IOnRiskReportColumnProp) => (data.paymentOutstanding ? `£${commonUtils.formatNumberWithCommas(data.paymentOutstanding)}` : '-'),
  },
  {
    name: 'totalOnRiskPaymentsOutstandingYtd',
    header: 'Total On Risk Payments Outstanding YTD',
    defaultFlex: 1,
    type: 'number',
    render: ({ data }: IOnRiskReportColumnProp) =>
      data.totalOnRiskPaymentsOutstandingYtd ? `£${commonUtils.formatNumberWithCommas(data.totalOnRiskPaymentsOutstandingYtd)}` : '-',
  },
]

export const generateDetailsColumns = (currentUser: IContextUser) => {
  const columns = [
    {
      name: 'companyName',
      header: 'Company Name',
      defaultFlex: 1,
      type: 'text',
      hide: currentUser.role !== 'superAdmin',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
    },
    {
      name: 'advisorName',
      header: 'Adviser Name',
      defaultFlex: 1,
      type: 'text',
      hide: currentUser.role !== 'superAdmin',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
    },
    {
      name: 'clientName',
      header: 'Client name',
      defaultFlex: 1,
      type: 'text',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
    },
    {
      name: 'dateOfApplication',
      header: 'Date of application',
      defaultFlex: 1,
      type: 'date',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
      render: ({ data }: IDetailsColumnProp) => (data.dateOfApplication ? commonUtils.formatDate(data.dateOfApplication) : '-'),
    },
    {
      name: 'lenderProvider',
      header: 'LENDER/PROVIDER',
      defaultFlex: 1,
      type: 'text',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
    },
    {
      name: 'feeType',
      header: 'FEE TYPE',
      defaultFlex: 1,
      type: 'text',
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
    },
    {
      name: 'amount',
      header: 'Amount',
      defaultFlex: 1,
      type: 'number',
      render: ({ data }: IDetailsColumnProp) => (data.amount ? `£${commonUtils.formatNumberWithCommas(data.amount)}` : '-'),
      onRender: (cellProps: CellProps, { data }: IDetailsColumnProp) => {
        if (cellProps.style && typeof cellProps.style === 'object') {
          const bgColor = generateBgColor(data.status)
          ;(cellProps.style as React.CSSProperties).background = bgColor
        }
      },
    },
  ]

  return columns.filter((column) => !column?.hide)
}
